<template>
<div id="NavBar" style="align-content:center">
    <v-breadcrumbs :items="this.items" divider=">">
        <v-breadcrumbs-item
                slot="item"
                slot-scope="{ item }"
                exact
                :to="item.to">
            {{ item.text }}
        </v-breadcrumbs-item>
    </v-breadcrumbs>
</div>
</template>

<script>
  export default {
      name: 'NavBar.vue',
      data: function() {
        return {
          items: [
              {
                  text: 'Home',
                  disabled: false,
                  to: {name: 'Home'},
              },
              {
                   text: 'Paintings',
                   disabled: false,
                   to: 'Paintings',
              },
              {
                  text: 'Drawings',
                  disabled: false,
                  to: 'Drawings',
              }


          ]
      };
}
  }
</script>

<style scoped>

</style>
